var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "28px",
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Starting-Components",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "DG-TieOut-|-Starting-Components",
    transform: "translate(-2277.000000, -2367.000000)",
    fill: "#757575",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2304.75046,2393.28723 L2295.41066,2383.94743 C2298.91163,2379.66672 2298.44082,2373.39268 2294.3402,2369.68241 C2290.23957,2365.97214 2283.94985,2366.12921 2280.03953,2370.03953 C2276.12921,2373.94985 2275.97214,2380.23957 2279.68241,2384.3402 C2283.39268,2388.44082 2289.66672,2388.91163 2293.94743,2385.41066 L2303.28723,2394.75046 C2303.69897,2395.10307 2304.31273,2395.07936 2304.69604,2394.69604 C2305.07936,2394.31273 2305.10307,2393.69897 2304.75046,2393.28723 Z M2287.40957,2385.72199 C2282.82448,2385.72199 2279.10753,2382.00504 2279.10753,2377.41995 C2279.10753,2372.83486 2282.82448,2369.11791 2287.40957,2369.11791 C2291.99466,2369.11791 2295.71161,2372.83486 2295.71161,2377.41995 C2295.71161,2379.62179 2294.83694,2381.73344 2293.28,2383.29038 C2291.72307,2384.84731 2289.61141,2385.72199 2287.40957,2385.72199 Z",
    id: "search"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.16a99c3957b5959ec0c1d09deaf83463.svg";
export { ForwardRef as ReactComponent };